import { mergeStyleSets } from '@uifabric/merge-styles';
import * as theme from './../theme/colors';

const reviewClassNames = (): { [key: string]: string } => mergeStyleSets({
  review: {
    minWidth: 960,
    selectors: {
      '@media(max-width: 1024px)': {
        minWidth: '96vw'
      }
    }
  },
  title: {
    fontSize: 24
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  posting: {
    selectors: {
      '.ms-Button-flexContainer' : {
        flexDirection: 'row-reverse'
      },
      'i[data-icon-name]': {
        display: 'none'
      }
    }
  },
  orderSummary: {
    marginTop: '4ch',
    borderTop: `1px solid ${theme.paleGray}`,
    padding: '2ch 0',
    selectors: {
      h3: {
        fontSize: 18,
        fontWeight: 'normal'
      }
    }
  },
  orderPictures: {
    display: 'grid',
    gridTemplateColumns: '30fr 30fr 30fr',
    selectors: {
      '@media(max-width: 600px)': {
        gridTemplateColumns: '50fr 50fr'
      }
    }
  },
  orderPicture: {
    maxWidth: 180,
    marginBottom: 16,
    selectors: {
      '@media(max-width: 600px)': {
        maxWidth: '44vw'
      }
    }
  },
  photos: <any>{
    display: 'grid',
    rowGap: 16,
    columnGap: 12,
    paddingTop: 16,
    gridTemplateColumns: '30fr 30fr 30fr',
    selectors: {
      '.loaded-image-container': {
        marginBottom: 16
      },
      canvas : {
        maxWidth: '100%'
      },
      '@media(max-width: 600px)': {
        display: 'flex',
        flexWrap: 'wrap'
      }
    }
  },
  author: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    selectors: {
      '.ms-TextField-wrapper': {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'baseline'
      }
    }
  },
  comment: {
    selectors: {
      '& ::placeholder': {
        fontStyle: 'italic'
      }
    }
  }});

export default reviewClassNames;
